const CART_STORAGE_KEY = 'onlineTradeAppOneCart'

export default {
    CART_STORAGE_KEY
}
